import { useAtom } from 'jotai'
import { cn } from '../../../../../../app/utils/cn'
import { currentStep } from '../../../../../../app/store'

interface StepsProps {
  visible?: boolean
  totalSteps?: number
}
export default function Steps({ visible, totalSteps = 3 }: StepsProps) {
  const [step] = useAtom(currentStep)
  return (
    <div className={visible ? 'mb-8 mt-5 flex gap-2.5 max-sm:mb-4 max-sm:mt-3 max-sm:gap-2' : 'hidden'}>
      {new Array(totalSteps).fill(0).map((_, i) => (
        <div className="h-[20px] w-full rounded-full bg-white02 max-sm:h-[12px]" key={i}>
          <div
            className={cn(
              'h-full w-0 rounded-full bg-primary',
              step === i && 'w-1/2',
              step > i && 'w-full',
            )}
          />
        </div>
      ))}
    </div>
  )
}
